import React from 'react'

export default ()=>{
    return(
        <style>
            {`


 body{
  font-family: 'Open Sans', sans-serif;
    font-size: 12px;
    font-size: 1.20rem;
    font-weight: 400;
    line-height: 1.625;
    margin: 0;
}
.privacyPolicy{
    background-color: #eee;
    padding:60px;
}

.site-inner{
 background-color: white;
box-sizing: inherit;
margin: 0 auto;
clear: both;
padding-top: 40px;
word-wrap: break-word;
max-width: 880px;
}

.site-inner.content-sidebar-wrap{
box-sizing: inherit;
}
.content{
display: block;
margin-right:0!important;

width: 100%;
 }


.content .entry {
    background-color: #fff;
    margin-bottom: 40px;
    padding: 70px 80px;
}
.entry-header{
text-align: center;
}
.entry-header::after {
    border-bottom: 1px solid #000;
    content: '';
    display: block;
    margin: 0 auto 40px;
    padding-bottom: 10px;
    width: 80px;
}

.entry-title{
font-family: 'Arbutus Slab', serif;
font-weight: 400;
line-height: 1.2;
margin: 0 0 10px;
font-size: 2.5rem;
}


strong {
    font-weight: 700;
}
.entry-content>p {
    margin: 0 0 28px;

}
.entry-content ol, .entry-content ul {
    margin-bottom: 28px;
    margin-left: -22px;
}
.entry-content ol > li {
    list-style-type: decimal;
}
.pad-left60{
    padding-left: 20px!important;
}
.pad-left90{
    padding-left: 55px!important;
}
.font-weight400{
font-weight:400;
}
.width-179{
width:179px;
}
.width-375{
width:375px;
}
.privacy-table{
    border-collapse: collapse;
    border-spacing: 0;
    line-height: 2;
    margin-bottom: 40px;
    width: 100%;
    word-break: break-all;
    border-color: grey;
    display: table;

}
.privacy-table>tbody {
    border-bottom: 1px solid #eee;
}
.privacy-table >tbody >tr{
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}
.privacy-table >tbody >tr >td:first-child,.privacy-table >tbody >tr >th:first-child {
    padding-left: 0;
}
.privacy-table >tbody >tr >td {
    border-top: 1px solid #eee;
    padding: 6px;
}
.privacy-table >tbody >tr >td,.privacy-table >tbody >tr >th {
    text-align: left;
}



            `}
        </style>
    );
}